function calculateOxidationFactor(carbonInAsh?: number, totalCarbon?: number) {
  if (!carbonInAsh || !totalCarbon) {
    return 1 // default value
  }
  return 1 - carbonInAsh / totalCarbon
}

export default function calculateCombustionEmissions({
  fuelConsumed,
  netCalorificValuePgGg,
  emissionFactorTco2pTJ,
  carbonInAsh,
  totalCarbon
}: {
  fuelConsumed: number
  netCalorificValuePgGg: number | null
  emissionFactorTco2pTJ: number
  carbonInAsh?: number
  totalCarbon?: number
}) {
  const FQi = fuelConsumed
  const NCVi = netCalorificValuePgGg || 1
  const ADi = FQi * NCVi // Equation 6
  const EFi = emissionFactorTco2pTJ / 1000 // tCO2/tJ

  // The oxidation factor is assumed to be 1, see:
  // https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=OJ%3AJOL_2023_228_R_0006#d1e32-113-1:~:text=The%20conservative%20assumption%20that%20OF%20%3D%201%20may%20always%20be%20used%20in%20order%20to%20reduce%20monitoring%20efforts.
  const OFi = calculateOxidationFactor(carbonInAsh, totalCarbon) // Equation 7
  const EMi = ADi * EFi * OFi // Equation 5

  return { emission: EMi, parameters: { NCVi, FQi, EFi, ADi, OFi, EMi } }
}
